@if (showSpinner) {
  <app-loader> </app-loader>
}
@if (isNewsUpdateShow && isNewsUpdateModalShow) {
  <app-news-updates [mediaObject]="mediaObject"></app-news-updates>
}


<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="main-section d-flex">
      <div class=" left-content-section">
        <div class="row">
          <div class="col-sm-6 col-md-7 pr-2 userinfo-section-main"
            [ngClass]="{ 'col-sm-12 col-md-12 pr-3': event.length == 0  }">
            <div class="col-12 user-title-section">
              <div class="col-12 row user-title-inner pr-0">

                <div class="user-title-name-section col-12 col-md-7 pr-0 text-left">
                  <p class="m-0">Hello have a good day!</p>
                  <h5 class="m-0">{{ first_name }} {{ last_name }}</h5>
                  <p class="welcome-text m-0">Welcome to the Work Insight</p>
                </div>
                <div class="title-image col-12 col-md-5 pr-0">
                  <ng-lottie width="300px" height="auto" [options]="options"></ng-lottie>
                </div>
              </div>
            </div>
          </div>
          @if (event.length != 0) {
            <div class="col-sm-6 col-md-5  pl-0 event-section-main event-padding">
              @if (event != null) {
                <div class="event-image-section pl-2" [style.backgroundImage]="'url(' + eventImageUrl + ')'"
                  data-toggle="modal" data-target="#eventModalCenter">
                  <div class="col-12 row event-title-inner pr-0">
                    <div class="event-name-section col-12 pr-0">
                      <h5 class="m-0">{{event.event_name}}</h5>
                      <p class="m-0 mt-1">{{ eventDate | date:'dd MMM yyyy' }}</p>
                      <!-- <p class="event-text m-0">
                      {{event.event_description}}
                    </p> -->
                  </div>
                </div>
              </div>
            }
            <!-- Modal -->
            <div class="modal fade" id="eventModalCenter" tabindex="-1" role="dialog"
              aria-labelledby="eventModalCenterTitle" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered  " role="document">
                <div class="modal-content">
                  <!-- <div class="modal-header">
                  <h5 class="modal-title">Event Detail</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div> -->
                <div class="modal-body">
                  <img src="{{eventImageUrl}}" (error)="handleImageError()" alt="Event Image">
                  <div class="event-detail row col-12 mt-3 ">
                    <h5 class="m-0 event-name-head ">{{event.event_name}}</h5>
                  </div>
                  <div class="event-detail event-detail-justify row col-12 mt-2 ">
                    <h5 class="m-0 event-name-text "><i class="fa fa-calendar"></i> {{ eventDate | date:'dd MMM yyyy'
                  }}</h5>
                  <h5 class="m-0 event-name-text"> <i class="fa fa-map-marker mr-1"></i> {{event.event_location}}
                </h5>
              </div>
              <div class="event-detail row col-12 mt-2 pr-0">
                <h5 class="m-0 event-text-des"> {{event.event_description}}</h5>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
<div class="employees-detail-section row p-md-3">
  <div class="col-md-6 total-employees-counter-inner">
    <div class="total-employees-counter p-3" [ngClass]="{ 'dark-mode-background': selectedMode === 'dark' }">
      <div class="total-employee-head d-flex justify-content-between p-0 pt-2">
        <div class="user-icon">
          <!-- <img src="../../assets/images/user-icon.svg" /> -->
          <ng-lottie width="50px" height="auto" [options]="HeadCount"></ng-lottie>
        </div>
        <div class="user-icon-option" [routerLink]="['/employee-payroll-managment']">
          <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 7.86523H17.5M17.5 7.86523L11.5 1.86523M17.5 7.86523L11.5 13.8652"
              [attr.stroke]="selectedMode === 'dark' ? 'white' : '#0071B9'" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            </svg>



          </div>
        </div>
        <div class="total-employee-body d-flex justify-content-between p-0 mt-2">
          <div class="total-employee-body-heading" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
            <p class="mb-0">Total</p>
            <h6 class="mb-0">Head Count</h6>
          </div>
          <div class="total-employees-number" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
            <p class="mb-0">{{ total_user }}</p>
          </div>
        </div>
        <div class="total-employee-counter d-flex justify-content-between p-0 mt-4">
          <div class="web-team-counter team-counter"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">{{ (deparment_name_first | slice:0:10) ?? 'Add New' + '...' }}</p>
            <h6 class="m-0">{{deparment_user_count_first }}</h6>
          </div>
          <div class="mobile-team-counter team-counter"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">{{(deparment_name_second | slice:0:10) ?? 'Add New' + '...' }}</p>
            <h6 class="m-0">{{deparment_user_count_second }}</h6>
          </div>
          <div class="design-team-counter team-counter"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">{{(deparment_name_third | slice:0:10) ?? 'Add New' + '...' }}</p>
            <h6 class="m-0">{{deparment_user_count_third }}</h6>
          </div>
          <div class="business-team-counter team-counter"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">{{(deparment_name_fourth | slice:0:10) ?? 'Add New' + '...' }}</p>
            <h6 class="m-0">{{deparment_user_count_fourth }}</h6>
          </div>
          <div class="other-team-counter team-counter other-section"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">Other Teams</p>
            <h6 class="m-0">{{ total_other }}</h6>
          </div>
          <div class="other-team-counter team-counter1 popup" (click)="toggleOtherPopup()"
            [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
            <p class="m-0 pb-1">...</p>
            <span class="popuptext" [ngClass]="{'show': isPopupVisible}">Other's : {{total_other}} </span>
          </div>
        </div>
      </div>
    </div>




    <div class="col-md-6 leave-employees-counter-inner pb-2 pr-0">
      <div class="leave-employees-counter p-3" [ngClass]="{ 'dark-mode-background': selectedMode === 'dark' }">
        <div class="leave-employee-head d-flex justify-content-between p-0 pt-2">
          <div class="user-icon1">
            <!-- <img src="../../assets/images/leave-counte.svg" /> -->
            <ng-lottie width="50px" height="auto" [options]="Leaves"></ng-lottie>
          </div>
          <div class="user-icon-option" [routerLink]="['/show-leaves']">
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 7.86523H17.5M17.5 7.86523L11.5 1.86523M17.5 7.86523L11.5 13.8652"
                [attr.stroke]="selectedMode === 'dark' ? 'white' : '#0071B9'" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
          </div>
          <div class="leave-employee-body d-flex justify-content-between p-0 mt-2">
            <div class="leave-employee-body-heading" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
              <p class="mb-0">Total</p>
              <h6 class="mb-0">Leaves <span>(Current Month)</span></h6>
            </div>
            <div class="leave-employees-number" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
              <p class="mb-0">{{ total_leaves }}</p>
            </div>
          </div>
          <div class="leave-employee-counter d-flex justify-content-between p-0 mt-4">
            <div class="paidleave-counter leave-counter"
              [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
              <p class="m-0 pb-1">
                <img src="../../assets/images/paid-leave.svg" />Paid
              </p>
              <h6 class="m-0">{{ total_paid_leaves }}</h6>
            </div>
            <div class="unpaidleave-counter leave-counter"
              [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
              <p class="m-0 pb-1">
                <img src="../../assets/images/unpaid-leave.svg" />Un-paid
              </p>
              <h6 class="m-0">{{ total_unpaid_leaves }}</h6>
            </div>
            <div class="absents-counter leave-counter"
              [ngClass]="{ 'dark-mode-inner-background': selectedMode === 'dark' }">
              <p class="m-0 pb-1">
                <img src="../../assets/images/absents.svg" />Absents
              </p>
              <h6 class="m-0">{{ total_absent }}</h6>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="evaluation-section event-padding p-3 py-2 mb-2"
      [ngClass]="{ 'dark-mode-background': selectedMode === 'dark' }">
      <div class="row evaluation-row p-3">
        <div class="col-12 evaluation-section-head p-0" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
          <h1>Top 3 Evaluations</h1>
        </div>
        <div class="col-12 mt-2 p-0">
          <div class="evaluation-section-inner px-0 p-0">
            @for (data of usersToDisplay; track data; let last = $last) {
              <div class="user-evaluation1 col-12" [ngClass]="{ 'no-border': last }">
                <div class="row">
                  @if (data.user) {
                    <div class="user-image">
                      <img [src]="data.user.profile_image" />
                    </div>
                  }
                  @if (!data.user) {
                    <div class="user-image">
                      <img src="../../assets/images/question.jpg" />
                    </div>
                  }
                  <div class="user-evaluation-detail ml-2 popup1"
                    [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }" (click)="togglePopup(data)">
                    @if (data.user) {
                      <p class="m-0 user_name">
                        {{ data.user.first_name }} {{ data.user.last_name }}
                        <span class="popuptext1" [ngClass]="{'show': data.isPopupVisible}">
                          {{ data.user.first_name }} {{ data.user.last_name }}<br>
                          {{ data.user.department }}
                        </span>
                      </p>
                    }
                    @if (!data.user) {
                      <p class="m-0 user_name">
                        Unknown User
                      </p>
                    }
                    <p class="m-0 evaluation">
                      <img class="mr-2" src="../../assets/images/winner_icon.svg" />{{ data.pm_points }}
                    </p>
                    <p class="m-0 team_detail" [ngClass]="{ 'dark-mode-dep': selectedMode === 'dark' }">
                      {{ data.user.department || 'Unknown Department' }}
                    </p>
                  </div>
                </div>
              </div>
            }


          </div>
        </div>
      </div>
    </div>

    <!-- user-request-section -->
    <div class="user-request-section-main col-12 py-2 p-0">
      <div class="user-req-sections">
        <div class="user-request-section" [ngClass]="{ 'dark-mode-background': selectedMode === 'dark' }">
          <div class="user-request-section-shape"></div>
          <div class="icones row justify-content-between">
            <div class="user-request-section-icon">
              <!-- <img src="../../assets/images/request-icon.svg" /> -->
              <ng-lottie width="50px" height="auto" [options]="Loan"></ng-lottie>
            </div>
            <div class="user-request-section-arrow" [routerLink]="['/loan-report']">
              <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.5 7.86523H17.5M17.5 7.86523L11.5 1.86523M17.5 7.86523L11.5 13.8652"
                  [attr.stroke]="selectedMode === 'dark' ? 'white' : '#0071B9'" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <div class="user-request-detail row justify-content-between">
              <div class="user-request-section-detail" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
                <p class="mb-0">Total</p>
                <h5 class="mb-0">Loan Request</h5>
              </div>
              <div class="user-request-section-counter" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
                <h4 class="mb-0">{{total_loan_request_count}}</h4>
              </div>
            </div>
          </div>
          <div class="user-request-section" [ngClass]="{ 'dark-mode-background': selectedMode === 'dark' }">
            <div class="user-request-section-shape"></div>
            <div class="icones row justify-content-between">
              <div class="user-request-section-icon">
                <ng-lottie width="50px" height="auto" [options]="Attendance"></ng-lottie>
                <!-- <img src="../../assets/images/attendace-icon.svg" /> -->

              </div>
              <div class="user-request-section-arrow" [routerLink]="['/user-attendance-list']">
                <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 7.86523H17.5M17.5 7.86523L11.5 1.86523M17.5 7.86523L11.5 13.8652"
                    [attr.stroke]="selectedMode === 'dark' ? 'white' : '#0071B9'" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <div class="user-request-detail row justify-content-between">
                <div class="user-request-section-detail" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
                  <p class="mb-0">Total</p>
                  <h5 class="mb-0">Attendance Request</h5>
                </div>
                <div class="user-request-section-counter" [ngClass]="{ 'dark-mode-text': selectedMode === 'dark' }">
                  <h4 class="mb-0">{{total_attendance_req}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class=" right-sidebar">
        <div class="right-sidebar-outer px-2">
          <div class="row">
            <div class="user-detail col-12" [ngClass]="{ 'dark-mode-bg1': selectedMode === 'dark' }">
              <div class="row user-info-side user-detail-inner pt-3 pl-3 pr-3">
                @if (profile_image !== '') {
                  <div class="side-user-image">
                    <img [src]="profile_image" />
                  </div>
                }

                @if (!profile_image || profile_image === '') {
                  <div class="side-user-image">
                    <img src="../../assets/images/question.jpg" />
                  </div>
                }
                <div class="user-info pl-2">
                  <h5 class="mb-0">
                    {{ getUser().first_name + " " + getUser().last_name }}
                  </h5>
                  <p class="mb-0">{{ getUser().department }}</p>
                </div>
              </div>
              <div class="row user-detail-inner pt-3 pl-3 pr-3">
                <div class="phone-icon" [ngClass]="{ 'dark-mode-icon-background': selectedMode === 'dark' }">
                  <!-- <img src="../../assets/images/phone.svg" /> -->
                  <ng-lottie width="50px" height="auto" [options]="phone"></ng-lottie>
                </div>
                <div class="user-no pl-2">
                  <label class="mb-0">Phone Number:</label>
                  <p class="mb-0">{{ getUser().phone_number }}</p>
                </div>
              </div>
              <div class="row user-detail-inner pt-1 pl-3 pr-3">
                <div class="phone-icon" [ngClass]="{ 'dark-mode-icon-background': selectedMode === 'dark' }">
                  <!-- <img src="../../assets/images/mail-04.svg" /> -->
                  <ng-lottie width="110px" height="auto" [options]="email_anim"></ng-lottie>

                </div>
                <div class="user-mail pl-2">
                  <label class="mb-0">Mail:</label>
                  <p class="mb-0">{{ getUser().email }}</p>
                </div>
              </div>

              <div class="row user-detail-inner pt-1 pl-3 pr-3">
                <div class="phone-icon" [ngClass]="{ 'dark-mode-icon-background': selectedMode === 'dark' }">
                  <!-- <img src="../../assets/images/location-icon.svg" /> -->
                  <ng-lottie width="23px" height="auto" [options]="address_anim"></ng-lottie>

                </div>
                <div class="user-no pl-2">
                  <label class="mb-0">Address:</label>
                  <p class="mb-0">{{ address.address1 }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="row aniversary-counter-row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
              <div class="birthday-timer-section right-sidebar-inner">


                <div class="birthday-timer-footer  px-2 py-3"
                  [ngClass]="{ 'birthday-timer-footer-background': selectedMode === 'dark' }">
                  <div class="birthday-timer-footer-top">
                    <h1>{{anniversary_count}} Anniversary</h1>
                  </div>

                  <div class="birthday-timer-footer-bottom pt-2 pb-3">
                    <div class="counter-box days">
                      <div class="counter-box-value" id="day-one"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <div class="counter-box-value mx-1" id="day-two"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <div class="counter-box-value" id="day-three"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <span>Days</span>
                    </div>
                    <div class="counter-box days counter-colon">
                      <div class="colon-one my-1"></div>
                      <div class="colon-one my-1"></div>
                    </div>
                    <div class="counter-box days">
                      <div class="counter-box-value mr-1" id="hour-one"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <div class="counter-box-value" id="hour-two"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <span>Hours</span>
                    </div>
                    <div class="counter-box days counter-colon">
                      <div class="colon-one my-1"></div>
                      <div class="colon-one my-1"></div>
                    </div>
                    <div class="counter-box days">
                      <div class="counter-box-value mr-1" id="min-one"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <div class="counter-box-value" id="min-two"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <span>Minutes</span>
                    </div>
                    <div class="counter-box days counter-colon">
                      <div class="colon-one my-1"></div>
                      <div class="colon-one my-1"></div>
                    </div>
                    <div class="counter-box days">
                      <div class="counter-box-value mr-1" id="sec-one"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <div class="counter-box-value" id="sec-two"
                        [ngClass]="{ 'counter-box-value-dark': selectedMode === 'dark' }">

                      </div>
                      <span>Seconds</span>
                    </div>

                  </div>

                </div>

              </div>
            </div>

          </div>

          <div class="row">
            <div class="birthday-section col-12 mt-2 pt-3 pl-3 pr-3"
              [ngClass]="{ 'dark-birthday-section': selectedMode === 'dark' }">
              <div class="row">
                <div class="birthday-text col-6 p-0">
                  <img src="../../assets/images/birthday-txt.svg" />
                  <p class="mb-0">
                    {{ birthday }}
                  </p>
                </div>
                <div class="cake-image col-6 p-0">
                  <!-- <img src="../../assets/images/cake.svg" /> -->
                  <ng-lottie width="100%" height="auto" [options]="cake"></ng-lottie>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="event-section col-12 mt-2 p-0">
              <!-- <div *ngFor="let imageUrl of media_url"> -->
              <img [src]="imageUrl" />
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</main>